import {FileRepository} from "../../shared/domain/FileRepository"
import { v4 as uuidv4 } from 'uuid';
import awsconfig from '../../../aws-exports';
import { Auth} from "aws-amplify";

export class S3Repository implements FileRepository{
  s3:any;
  type:string;
  files:any[];

  constructor(AWS, type?:string){
    this.s3 = new AWS.S3({
      apiVersion: "2006-03-01",
      params: { Bucket: awsconfig['aws_user_files_s3_bucket'] }
    });
    if(type){
      this.type = type
    }else {
      this.type = 'payment'
    }
  }

  async uploadFile(file) {
    const uuid = uuidv4()
    const cc = await Auth.currentCredentials()
    let spl = file.name.split('.')
    let ext = spl[spl.length-1]
    await this.s3.upload({   
        Bucket: awsconfig['aws_user_files_s3_bucket'],     
        Key: 'private/'+cc.identityId+'/'+this.type+'/'+uuid+'.'+ext,
        Body: file,
        ACL: 'private',
        contentType: 'application/pdf',
        CacheControl: 'max-age=0, public'
      }).promise()
      return cc.identityId+'/'+this.type+'/'+uuid+'.'+ext
  }
}

export class MemoryS3Repository implements FileRepository{
  files:any=[]

  async uploadFile(file) {
    this.files.push(file)
    let name = file.name
    return 'path/' + name
  }
}